export interface ICustomerEvent {
    completionDate: string;
    completionBy: string;
    eventCode: string;
    eventDisplayName: string;
    eventDescription: string;
    eventOutcomeCode: string;
    isOptional: boolean;
}

export class CustomerEvent implements ICustomerEvent {
    completionDate: string;
    completionBy: string;
    eventCode: string;
    eventDisplayName: string;
    eventDescription: string;
    eventOutcomeCode: string;
    isOptional: boolean;
}
